const SCOPE = 'platform-group'

export const AUTH_TOKEN_KEY = `${SCOPE}/admin/token`
export const USER_KEY = `${SCOPE}/admin/user`
export const AUTHENTICATION_IN_FLIGHT = `${SCOPE}/irwin/authentication-in-flight`
export const DATAGRID_KEY = `${SCOPE}/datagrid`

export const CUSTOMER_ID = `${SCOPE}/admin/customer-id`
